// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom'; // 1. Import navigation hook
// import { Mail, Lock, ShieldCheck, Loader2 } from 'lucide-react';

// export default function LoginScreen() {
//   const navigate = useNavigate(); // 2. Initialize the redirect engine
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');

//   const handleLoginSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setErrorMessage('');

//     try {
//       const response = await fetch('https://metapi.emedhatechnologies.com/auth/api/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || 'Authentication failed');
//       }

//       // 3. SECURE THE SESSION DATA
//       sessionStorage.setItem('isLoggedIn', 'true');
//       sessionStorage.setItem('userSession', JSON.stringify(data.user));

//       // 4. Smoothly route them directly into the Dashboard Workspace
//       navigate('/dashboard', { replace: true });
      
//     } catch (error) {
//       setErrorMessage(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Absolute Ambient Layer */}
//       <div style={styles.ambientWrapper}>
//         <div style={styles.glowLeft}></div>
//         <div style={styles.glowRight}></div>
//       </div>

//       {/* Luxury Glass Card */}
//       <div style={styles.card}>
//         <div style={styles.header}>
//           <span style={styles.badge}>
//             <ShieldCheck size={12} style={{ marginRight: '6px' }} />
//             MET Academy Management
//           </span>
//           <h1 style={styles.title}>Welcome Back</h1>
//           <p style={styles.subtitle}>Please enter your administrative access keys</p>
//         </div>

//         {errorMessage && <div style={styles.errorAlert}>{errorMessage}</div>}

//         <form onSubmit={handleLoginSubmit} style={styles.formContainer}>
//           <div style={styles.inputWrapper}>
//             <Mail size={18} style={styles.inputIcon} />
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//               placeholder="Email Address"
//               required
//             />
//           </div>

//           <div style={styles.inputWrapper}>
//             <Lock size={18} style={styles.inputIcon} />
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//               placeholder="Security Password"
//               required
//             />
//           </div>

//           <button 
//             type="submit" 
//             style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button} 
//             disabled={loading}
//           >
//             {loading ? (
//               <span style={styles.btnContent}>
//                 <Loader2 size={16} style={styles.spinner} /> Authenticating...
//               </span>
//             ) : (
//               'Authenticate Access'
//             )}
//           </button>
//         </form>

//         <div style={styles.footerNote}>
//           Protected Workspace Core &bull; Secure Session System
//         </div>
//       </div>

//       {/* Global Page Reset & Keyframes Injection */}
//       <style dangerouslySetInnerHTML={{__html: `
//         html, body {
//           margin: 0;
//           padding: 0;
//           width: 100%;
//           overflow-x: hidden;
//           background-color: #040812;
//         }
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         @keyframes subtlePulse {
//           0% { transform: scale(1); opacity: 0.8; }
//           50% { transform: scale(1.03); opacity: 1; }
//           100% { transform: scale(1); opacity: 0.8; }
//         }
//       `}} />
//     </div>
//   );
// }

// const styles = {
//   container: {
//     background: '#040812',
//     minHeight: '100vh',
//     width: '100%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '24px',
//     position: 'relative',
//     overflow: 'hidden',
//     boxSizing: 'border-box',
//   },
//   ambientWrapper: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     overflow: 'hidden',
//     zIndex: 1,
//     pointerEvents: 'none',
//   },
//   glowLeft: {
//     position: 'absolute',
//     width: '500px',
//     height: '500px',
//     background: 'radial-gradient(circle, rgba(69, 155, 242, 0.12) 0%, rgba(0,0,0,0) 70%)',
//     top: '-15%',
//     left: '-10%',
//     animation: 'subtlePulse 8s infinite ease-in-out',
//   },
//   glowRight: {
//     position: 'absolute',
//     width: '550px',
//     height: '550px',
//     background: 'radial-gradient(circle, rgba(227, 5, 4, 0.05) 0%, rgba(0,0,0,0) 70%)',
//     bottom: '-20%',
//     right: '-10%',
//     animation: 'subtlePulse 10s infinite ease-in-out',
//   },
//   card: {
//     background: 'rgba(255, 255, 255, 0.02)',
//     border: '1px solid rgba(255, 255, 255, 0.06)',
//     backdropFilter: 'blur(30px)',
//     WebkitBackdropFilter: 'blur(30px)',
//     width: '100%',
//     maxWidth: '410px',
//     borderRadius: '24px',
//     padding: '40px 32px',
//     boxShadow: '0 40px 80px -20px rgba(0, 0, 0, 0.7), inset 0 1px 1px rgba(255,255,255,0.05)',
//     zIndex: 2,
//     display: 'flex',
//     flexDirection: 'column',
//     boxSizing: 'border-box',
//   },
//   header: {
//     textAlign: 'center',
//     marginBottom: '28px',
//   },
//   badge: {
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '6px 14px',
//     background: 'rgba(227, 5, 4, 0.08)',
//     border: '1px solid rgba(227, 5, 4, 0.2)',
//     borderRadius: '100px',
//     color: '#e30504',
//     fontSize: '11px',
//     fontWeight: '700',
//     textTransform: 'uppercase',
//     letterSpacing: '1px',
//     marginBottom: '16px',
//   },
//   title: {
//     color: '#ffffff',
//     fontSize: '26px',
//     fontWeight: '600',
//     letterSpacing: '-0.5px',
//     margin: 0,
//   },
//   subtitle: {
//     color: 'rgba(255, 255, 255, 0.4)',
//     fontSize: '13.5px',
//     marginTop: '8px',
//     lineHeight: '1.4',
//   },
//   formContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//   },
//   inputWrapper: {
//     position: 'relative',
//     width: '100%',
//     display: 'flex',
//     alignItems: 'center',
//     boxSizing: 'border-box',
//   },
//   inputIcon: {
//     position: 'absolute',
//     left: '16px',
//     color: 'rgba(255, 255, 255, 0.3)',
//     pointerEvents: 'none',
//   },
//   input: {
//     width: '100%',
//     padding: '15px 16px 15px 46px',
//     background: 'rgba(0, 0, 0, 0.25)',
//     border: '1px solid rgba(255, 255, 255, 0.1)',
//     borderRadius: '12px',
//     outline: 'none',
//     color: '#ffffff',
//     fontSize: '14px',
//     boxSizing: 'border-box',
//   },
//   button: {
//     width: '100%',
//     padding: '15px',
//     background: 'linear-gradient(90deg, #459bf2 0%, #1c6ec9 100%)',
//     border: 'none',
//     borderRadius: '12px',
//     color: '#ffffff',
//     fontSize: '14.5px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     boxShadow: '0 4px 20px rgba(69, 155, 242, 0.2)',
//     transition: 'all 0.25s ease',
//     marginTop: '6px',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     boxSizing: 'border-box',
//   },
//   buttonDisabled: {
//     background: 'rgba(69, 155, 242, 0.4)',
//     cursor: 'not-allowed',
//     boxShadow: 'none',
//   },
//   btnContent: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//   },
//   spinner: {
//     animation: 'spin 1s linear infinite',
//   },
//   errorAlert: {
//     background: 'rgba(227, 5, 4, 0.1)',
//     border: '1px solid rgba(227, 5, 4, 0.3)',
//     color: '#ffffff',
//     padding: '12px',
//     borderRadius: '10px',
//     fontSize: '13px',
//     marginBottom: '16px',
//     textAlign: 'center',
//   },
//   footerNote: {
//     textAlign: 'center',
//     marginTop: '28px',
//     fontSize: '11px',
//     color: 'rgba(255, 255, 255, 0.2)',
//     letterSpacing: '0.5px',
//   },
// };

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Mail, Lock, ShieldCheck, Loader2 } from 'lucide-react';

// export default function LoginScreen() {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');

//   const handleLoginSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setErrorMessage('');

//     try {
//       const response = await fetch('https://metapi.emedhatechnologies.com/auth/api/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || 'Authentication failed');
//       }

//       // 🔐 CACHE THE USER PARAMETERS & THE PERMISSION MATRIX INTO SESSION STORAGE
//       sessionStorage.setItem('isLoggedIn', 'true');
//       sessionStorage.setItem('userSession', JSON.stringify(data.user));

//       // Direct redirect to workspace dashboard
//       navigate('/dashboard', { replace: true });
      
//     } catch (error) {
//       setErrorMessage(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.ambientWrapper}>
//         <div style={styles.glowLeft}></div>
//         <div style={styles.glowRight}></div>
//       </div>

//       <div style={styles.card}>
//         <div style={styles.header}>
//           <span style={styles.badge}>
//             <ShieldCheck size={12} style={{ marginRight: '6px' }} />
//             MET Academy Management
//           </span>
//           <h1 style={styles.title}>Welcome Back</h1>
//           <p style={styles.subtitle}>Please enter your administrative access keys</p>
//         </div>

//         {errorMessage && <div style={styles.errorAlert}>{errorMessage}</div>}

//         <form onSubmit={handleLoginSubmit} style={styles.formContainer}>
//           <div style={styles.inputWrapper}>
//             <Mail size={18} style={styles.inputIcon} />
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//               placeholder="Email Address"
//               required
//             />
//           </div>

//           <div style={styles.inputWrapper}>
//             <Lock size={18} style={styles.inputIcon} />
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//               placeholder="Security Password"
//               required
//             />
//           </div>

//           <button type="submit" style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button} disabled={loading}>
//             {loading ? <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} /> : 'Authenticate Access'}
//           </button>
//         </form>

//         <div style={styles.footerNote}>Protected Workspace Core &bull; Secure Session System</div>
//       </div>
//       <style dangerouslySetInnerHTML={{__html: `
//         html, body { margin: 0; padding: 0; width: 100%; overflow-x: hidden; background-color: #040812; }
//         @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
//       `}} />
//     </div>
//   );
// }

// const styles = {
//   container: { background: '#040812', minHeight: '100vh', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', position: 'relative', overflow: 'hidden', boxSizing: 'border-box' },
//   ambientWrapper: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', zIndex: 1, pointerEvents: 'none' },
//   glowLeft: { position: 'absolute', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(69, 155, 242, 0.12) 0%, rgba(0,0,0,0) 70%)', top: '-15%', left: '-10%' },
//   glowRight: { position: 'absolute', width: '550px', height: '550px', background: 'radial-gradient(circle, rgba(227, 5, 4, 0.05) 0%, rgba(0,0,0,0) 70%)', bottom: '-20%', right: '-10%' },
//   card: { background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.06)', backdropFilter: 'blur(30px)', WebkitBackdropFilter: 'blur(30px)', width: '100%', maxWidth: '410px', borderRadius: '24px', padding: '40px 32px', boxShadow: '0 40px 80px -20px rgba(0, 0, 0, 0.7)', zIndex: 2, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' },
//   header: { textAlign: 'center', marginBottom: '28px' },
//   badge: { display: 'inline-flex', alignItems: 'center', padding: '6px 14px', background: 'rgba(227, 5, 4, 0.08)', border: '1px solid rgba(227, 5, 4, 0.2)', borderRadius: '100px', color: '#e30504', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' },
//   title: { color: '#ffffff', fontSize: '26px', fontWeight: '600', marginTop: '16px' },
//   subtitle: { color: 'rgba(255, 255, 255, 0.4)', fontSize: '13.5px', marginTop: '8px' },
//   formContainer: { display: 'flex', flexDirection: 'column', gap: '16px' },
//   inputWrapper: { position: 'relative', width: '100%', display: 'flex', alignItems: 'center' },
//   inputIcon: { position: 'absolute', left: '16px', color: 'rgba(255, 255, 255, 0.3)' },
//   input: { width: '100%', padding: '15px 16px 15px 46px', background: 'rgba(0, 0, 0, 0.25)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '12px', outline: 'none', color: '#ffffff', fontSize: '14px', boxSizing: 'border-box' },
//   button: { width: '100%', padding: '15px', background: 'linear-gradient(90deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', borderRadius: '12px', color: '#ffffff', fontSize: '14.5px', fontWeight: '600', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' },
//   buttonDisabled: { background: 'rgba(69, 155, 242, 0.4)', cursor: 'not-allowed' },
//   footerNote: { textAlign: 'center', marginTop: '28px', fontSize: '11px', color: 'rgba(255, 255, 255, 0.2)' }
// };

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, ShieldCheck, Loader2 } from 'lucide-react';
import logo from '../Images/logo.jpeg'

export default function LoginScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const response = await fetch('https://metapi.emedhatechnologies.com/auth/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Authentication failed');
      }

      // 🔐 CACHE THE USER PARAMETERS & THE PERMISSION MATRIX INTO SESSION STORAGE
      sessionStorage.setItem('isLoggedIn', 'true');
      sessionStorage.setItem('userSession', JSON.stringify(data.user));

      // Direct redirect to workspace dashboard
      navigate('/dashboard', { replace: true });
      
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Premium Ambient Background Effects */}
      <div style={styles.ambientWrapper}>
        <div style={styles.glowLeft}></div>
        <div style={styles.glowRight}></div>
      </div>

      <div style={styles.card}>
        <div style={styles.header}>
          {/* Circular Brand Identity Crest Container */}
        {/* Premium Brand Logo Crest Image */}
<div style={styles.logoWrapper}>
  <img 
    src={logo} /* Place your image inside public/assets/logo.jpeg */
    alt="EDULEARNER Logo"
    style={styles.logoImage}
    onError={(e) => {
      // Fallback text if the image asset fails to load
      e.target.style.display = 'none';
    }}
  />
</div>

          <span style={styles.badge}>
            <ShieldCheck size={12} style={{ marginRight: '6px' }} />
            Administrative Portal
          </span>
          

        </div>

        {errorMessage && <div style={styles.errorAlert}>{errorMessage}</div>}

        <form onSubmit={handleLoginSubmit} style={styles.formContainer}>
          <div style={styles.inputWrapper}>
            <Mail size={18} style={styles.inputIcon} />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="Email Address"
              required
            />
          </div>

          <div style={styles.inputWrapper}>
            <Lock size={18} style={styles.inputIcon} />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Security Access Password"
              required
            />
          </div>

          <button type="submit" style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button} disabled={loading}>
            {loading ? <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} /> : 'Authorize Access Connection'}
          </button>
        </form>

        <div style={styles.footerNote}>
          Thiruvannamalai Campus &bull; Protected System Core
        </div>
      </div>
      <style dangerouslySetInnerHTML={{__html: `
        html, body { margin: 0; padding: 0; width: 100%; overflow-x: hidden; background-color: #030a16; font-family: 'Inter', sans-serif; }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}} />
    </div>
  );
}

// PREMIUM BRAND PALETTE: Navy Blue (#1c6ec9), Gold Accent (#d4af37)
const styles = {
  container: { background: '#020712', minHeight: '100vh', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 24px', position: 'relative', overflow: 'hidden', boxSizing: 'border-box' },
  ambientWrapper: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', zIndex: 1, pointerEvents: 'none' },
  glowLeft: { position: 'absolute', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(28, 110, 201, 0.15) 0%, rgba(0,0,0,0) 70%)', top: '-20%', left: '-15%' },
  glowRight: { position: 'absolute', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(212, 175, 55, 0.04) 0%, rgba(0,0,0,0) 70%)', bottom: '-25%', right: '-15%' },
  card: { background: 'rgba(15, 23, 42, 0.4)', border: '1px solid rgba(255, 255, 255, 0.06)', backdropFilter: 'blur(30px)', WebkitBackdropFilter: 'blur(30px)', width: '100%', maxWidth: '420px', borderRadius: '28px', padding: '40px 36px', boxShadow: '0 40px 100px -20px rgba(0, 0, 0, 0.8)', zIndex: 2, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' },
  header: { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: '24px' },
  
  // Premium Circular Gold Logo Layout
  logoContainer: { marginBottom: '20px' },
  logoRingOuter: { width: '80px', height: '80px', borderRadius: '50%', background: 'transparent', border: '2px solid #d4af37', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 15px rgba(212, 175, 55, 0.2)' },
  logoRingInner: { width: '100%', height: '100%', borderRadius: '50%', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', border: '1px solid rgba(212, 175, 55, 0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  logoAbbr: { color: '#d4af37', fontSize: '24px', fontWeight: '800', letterSpacing: '0.5px', fontFamily: 'serif' },
  
  badge: { display: 'inline-flex', alignItems: 'center', padding: '6px 14px', background: 'rgba(28, 110, 201, 0.08)', border: '1px solid rgba(28, 110, 201, 0.2)', borderRadius: '100px', color: '#459bf2', fontSize: '10.5px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' },
  title: { color: '#ffffff', fontSize: '28px', fontWeight: '800', marginTop: '16px', marginBottom: '2px', letterSpacing: '0.5px' },
  institutionType: { color: '#d4af37', fontSize: '12.5px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1.5px', margin: '0 0 12px 0' },
  subtitle: { color: 'rgba(255, 255, 255, 0.4)', fontSize: '13px', margin: 0 },
  
  formContainer: { display: 'flex', flexDirection: 'column', gap: '16px' },
  inputWrapper: { position: 'relative', width: '100%', display: 'flex', alignItems: 'center' },
  inputIcon: { position: 'absolute', left: '16px', color: 'rgba(255, 255, 255, 0.3)', pointerEvents: 'none' },
  input: { width: '100%', padding: '15px 16px 15px 48px', background: 'rgba(0, 0, 0, 0.3)', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: '14px', outline: 'none', color: '#ffffff', fontSize: '14px', boxSizing: 'border-box', transition: 'border 0.2s', ':focus': { borderColor: '#d4af37' } },
  // Replace your logo styles with these parameters
  logoWrapper: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    padding: '2px',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    boxShadow: '0 0 20px rgba(212, 175, 55, 0.15)',
    overflow: 'hidden'
  },
  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '50%'
  },
  button: { width: '100%', padding: '16px', background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', border: 'none', borderRadius: '14px', color: '#ffffff', fontSize: '14.5px', fontWeight: '600', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 4px 15px rgba(28, 110, 201, 0.2)', transition: 'transform 0.1s' },
  buttonDisabled: { background: 'rgba(28, 110, 201, 0.4)', cursor: 'not-allowed', boxShadow: 'none' },
  errorAlert: { width: '100%', padding: '12px 14px', background: 'rgba(227, 5, 4, 0.1)', border: '1px solid rgba(227, 5, 4, 0.2)', borderRadius: '12px', color: '#f87171', fontSize: '13px', fontWeight: '500', marginBottom: '16px', boxSizing: 'border-box', textAlign: 'center' },
  footerNote: { textAlign: 'center', marginTop: '32px', fontSize: '11px', color: 'rgba(255, 255, 255, 0.25)', letterSpacing: '0.3px' }
};